var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.046 3.486a.75.75 0 01-.032 1.06l-7.93 7.474a.85.85 0 01-1.188-.022l-2.68-2.72a.75.75 0 111.068-1.053l2.234 2.267 7.468-7.038a.75.75 0 011.06.032z",
    fill: "#000"
  })));
}
export default SvgCheckmark;